import defaultState from './state'

export default {
	SET_CREDIT_CARD_STATE (state, payload) {
		state[payload.field] = payload.value
	},
	RESET_STATE (state) {
		Object.assign(state, defaultState())
	}
}